import {apiRequest} from './api-request';
export function accountRequest(path,options={}){
  return apiRequest(path,{unavailable:'This account service is temporarily unavailable. Please try again.',cancelled:'Download cancelled. Your journal is unchanged.',...options});
}
